"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const index_1 = require("../../../../index");
const input_date_1 = __importDefault(require("../input-date"));
const style_1 = __importDefault(require("./style"));
const CustomInput = (0, react_1.forwardRef)(({ value, onClick, onChange, isSelectsRange, disabled, minYear, maxYear }, ref) => {
    const { CalendarIcon } = index_1.icon;
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const listener = (event) => {
            // Do nothing if clicking ref's element or descendent elements
            if (!inputRef.current ||
                inputRef.current.contains(event.target)) {
                return;
            }
            setIsFocused(false);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [inputRef, setIsFocused]);
    return (react_1.default.createElement(style_1.default, { onClick: onClick, ref: ref, isSelectsRange: isSelectsRange, disabled: disabled, isFocused: isFocused },
        isFocused && !isSelectsRange && (react_1.default.createElement(input_date_1.default, { value: value, onChange: onChange, minYear: minYear, maxYear: maxYear, inputRef: inputRef })),
        react_1.default.createElement("input", { onChange: onChange, value: value, onFocus: () => setIsFocused(true), disabled: disabled }),
        react_1.default.createElement("span", null,
            react_1.default.createElement(CalendarIcon, { className: "calendar-icon" }))));
});
exports.default = CustomInput;
